{
	"backLinkTitle": "Terug naar Verklaringen beheren",
	"invoicedQuantity": "Gefactureerde hoeveelheid",
	"remainingForDeclarationCreation": "Resterend voor het aanmaken van een verklaring",
	"nonTransferableAmount": "Niet-toewijsbaar bedrag",
	"btnCreateDeclaration": "+ Verklaring aanmaken",
	"errorMessage": "Materiaaldetails konden niet worden geladen"
}
